import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Testids } from '@hweeks/kei-costs-ui-testids';
import { CtaBand } from './CtaBand';
import { Spot, StampedSheet } from './illustrations';
import { MKT } from './links';
import { MarketingLayout } from './MarketingLayout';
import { NextLink, ProductFaq, ProductHero, ProductSection } from './ProductParts';
import { COMPS, PLOT_DOTS } from './ProductPricingGuidancePage.data';
import './product-pricing-guidance.css';
const STEPS = [
    {
        k: '壱',
        title: 'Match on what changes price',
        text: 'It starts with the same make and model and the closest years, then narrows on model code, grade and mileage. Whatever the listing leaves out, the sheet read fills in.'
    },
    {
        k: '弐',
        title: 'Use sold results only',
        text: 'Start prices and unsold lots don’t count. Each range lists the comps behind it, so you can judge them yourself.'
    },
    {
        k: '参',
        title: 'A range to bid in',
        text: 'Each range carries a confidence level, which makes thin comps easy to spot. The bid itself is yours to set.'
    }
];
// Product tour 03. Design: design-mockups/rhd-woodblock/Product-Pricing-Guidance.dc.html.
export default function ProductPricingGuidancePage() {
    return /*#__PURE__*/ _jsx(MarketingLayout, {
        testid: Testids.app.marketing.productRoot('pricing-guidance'),
        children: /*#__PURE__*/ _jsxs("main", {
            children: [
                /*#__PURE__*/ _jsx(ProductHero, {
                    k: "相場",
                    label: "Product · 03 Pricing guidance",
                    title: "Bid from what cars like it sold for.",
                    lead: "Every estimate lists the similar lots that sold, then turns them into a bid range you can use.",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "mk-ppg-card",
                        children: [
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mk-pp-mock-head",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "mk-ppg-card__car",
                                        children: "1999 Nissan Stagea RS Four V · 3.5"
                                    }),
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "mk-pp-mono-sm",
                                        children: "Lot 41207"
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mk-ppg-range",
                                children: [
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "mk-pp-kicker",
                                        children: "Suggested bid range"
                                    }),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "mk-ppg-range__value",
                                        children: "¥1,200,000 – ¥1,350,000"
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "mk-ppg-plot",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                className: "mk-ppg-plot__band"
                                            }),
                                            PLOT_DOTS.map((d)=>/*#__PURE__*/ _jsx("span", {
                                                    className: "mk-ppg-plot__dot",
                                                    style: d
                                                }, d.left))
                                        ]
                                    }),
                                    /*#__PURE__*/ _jsxs("div", {
                                        className: "mk-ppg-axis",
                                        children: [
                                            /*#__PURE__*/ _jsx("span", {
                                                children: "¥1.0M"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                children: "¥1.3M"
                                            }),
                                            /*#__PURE__*/ _jsx("span", {
                                                children: "¥1.6M"
                                            })
                                        ]
                                    })
                                ]
                            }),
                            /*#__PURE__*/ _jsxs("div", {
                                className: "mk-ppg-comps",
                                children: [
                                    COMPS.map((c)=>/*#__PURE__*/ _jsxs("div", {
                                            className: "mk-ppg-comp",
                                            children: [
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-ppg-comp__car",
                                                    children: c.car
                                                }),
                                                /*#__PURE__*/ _jsx("span", {
                                                    className: "mk-ppg-comp__date",
                                                    children: c.date
                                                }),
                                                /*#__PURE__*/ _jsx("b", {
                                                    className: "mk-ppg-comp__price",
                                                    children: c.price
                                                })
                                            ]
                                        }, c.car + c.date)),
                                    /*#__PURE__*/ _jsx("div", {
                                        className: "mk-ppg-comps__more",
                                        children: "11 comparable sold lots · view all"
                                    })
                                ]
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(Spot, {
                    width: 260,
                    children: /*#__PURE__*/ _jsx(StampedSheet, {})
                }),
                /*#__PURE__*/ _jsx(ProductSection, {
                    title: "Comparable lots in, a bid range out.",
                    children: /*#__PURE__*/ _jsx("div", {
                        className: "mk-ppg-steps",
                        children: STEPS.map((s)=>/*#__PURE__*/ _jsxs("div", {
                                className: "mk-ppg-step",
                                children: [
                                    /*#__PURE__*/ _jsx("span", {
                                        className: "mk-ppg-step__k",
                                        children: s.k
                                    }),
                                    /*#__PURE__*/ _jsx("h3", {
                                        className: "mk-ppg-step__title",
                                        children: s.title
                                    }),
                                    /*#__PURE__*/ _jsx("p", {
                                        className: "mk-ppg-step__text",
                                        children: s.text
                                    })
                                ]
                            }, s.k))
                    })
                }),
                /*#__PURE__*/ _jsx("section", {
                    className: "mk-ppg-why rhd-band-ai",
                    children: /*#__PURE__*/ _jsxs("div", {
                        className: "mk-ppg-why__inner",
                        children: [
                            /*#__PURE__*/ _jsx("span", {
                                className: "mk-ppg-why__k",
                                children: "実績"
                            }),
                            /*#__PURE__*/ _jsx("h2", {
                                className: "mk-pp-band-title",
                                children: "Why it uses real sold prices"
                            }),
                            /*#__PURE__*/ _jsx("p", {
                                className: "mk-ppg-why__text",
                                children: "JDM auction prices move with the season, the grade and demand. Bid off last year’s rule of thumb and you’ll come in too high or too low. What similar cars went for in the last few weeks is a better guide, so the estimate is built on that."
                            })
                        ]
                    })
                }),
                /*#__PURE__*/ _jsx(ProductFaq, {
                    title: "Pricing guidance questions",
                    items: [
                        [
                            'Where do the sold prices come from?',
                            'From results posted on the auction sites you search through JapanCarDirect, JDM Auc and Pacific Coast JDM. The app records every sold price it sees on a lot page and uses each one as a comp.'
                        ],
                        [
                            'Does it include fees and shipping?',
                            'No. It’s the hammer price only. Your landed cost comes from your paperwork and lives on the landed cost page.'
                        ]
                    ]
                }),
                /*#__PURE__*/ _jsx(NextLink, {
                    label: "Next · 04",
                    title: "Hunts & custom orders",
                    go: "探索 →",
                    href: MKT.product('hunts')
                }),
                /*#__PURE__*/ _jsx(CtaBand, {})
            ]
        })
    });
}
